import React, { useEffect, useRef } from 'react';
import AppInput from '../Inputs/AppInput';

export default function InlineEditor({ value, onChange, onSave, onCancel, placeholder, saveOnBlur = true, inputClassName = 'renameInput' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
      ref.current.select();
    }
  }, []);

  return (
    <AppInput
      ref={ref}
      className={inputClassName}
      placeholder={placeholder || ''}
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={() => { if (saveOnBlur) onSave?.({ source: 'blur' }); }}
      onKeyDown={e => {
        if (e.key === 'Enter') onSave?.({ source: 'enter' });
        if (e.key === 'Escape') onCancel();
      }}
      stopPropagation={true}
      preventDragStart={true}
    />
  );
}
